import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Middle_Ages_-_African_Kingdoms_e.g._Mali_Ghana.png';

function HistoryPageAfricaGo() {
  return (
    <QuizPage
      title="History: African Kingdoms"
      subTopic="African Kingdoms (e.g., Mali, Ghana)"
      backgroundImage={historyImage}
      returnPath="/History-African-Kingdoms"
    />
  );
}

export default HistoryPageAfricaGo;   